export default __webpack_public_path__ + "static/media/photo17.034c7493.jpeg";